
export class GetScannableCoursesRequestDto {
  date: Date;
}
